import { MoneyTransaction } from './money-transaction-model';

export class MoneyTransactionSubmittedData {
  moneyTransactionData: MoneyTransaction;
  tan: string;
  authorizationId: string;
}
